module.exports = __webpack_public_path__ + "static/media/undraw_developer-activity_4zqd.f18a66e8.svg";